import { IconType } from 'components/Icon';
import Section from 'components/Panel/Section';
import ColorInput from 'components/Widget/Input/ColorInput';
import TextInput from 'components/Widget/Input/TextInput';
import { Color, Style } from 'dragonmouse-shared/style';
import { MenuItemAction } from 'menu/MenuItem';
import React from 'react';
import { useDispatch } from 'react-redux';
import { showContextMenu } from 'redux/mode/actions';
import { displayViewOnlyModal } from 'redux/mode/util';
import * as Panel from '../../../styles';
import * as DS from '../styles';

interface ColorSetupProps {
	activeStyle: Style;
	updateCurrentStyle: (update: Partial<Style>) => void;
	viewOnly?: boolean;
}
const ColorSetup = ({ activeStyle, viewOnly, updateCurrentStyle }: ColorSetupProps) => {
	const dispatch = useDispatch();

	const onAddColor = () => {
		if (viewOnly) {
			displayViewOnlyModal();
			return;
		}
		if (!activeStyle) return;
		const color: Color = {
			title: '',
			hex: '#888888',
		};
		updateCurrentStyle({ colors: [...(activeStyle.colors || []), color] });
	};

	const onColorContextMenu = (e: React.MouseEvent, index: number) => {
		if (!activeStyle) return;
		if (e.target instanceof HTMLElement) {
			dispatch(
				showContextMenu({
					point: { x: e.clientX, y: e.clientY },
					menuItems: [
						new MenuItemAction('Delete color', '', () => {
							updateCurrentStyle({
								colors: activeStyle?.colors?.filter((_, i) => i !== index) ?? [],
							});
						}),
					],
				})
			);
		}
	};

	//------------------------------------------------------------------------------------------------
	// RENDERING
	//------------------------------------------------------------------------------------------------
	return (
		<Section
			label="Colors"
			actions={[
				{
					tooltip: 'Add color',
					icon: IconType.ADD,
					onClick: onAddColor,
				},
			]}
		>
			{activeStyle?.colors?.map((color, index) => (
				<DS.PropertyRow key={index} onContextMenu={(e) => onColorContextMenu(e, index)}>
					<DS.PropertyLabel>
						<TextInput
							value={color.title}
							placeholder="e.g. 'Primary'"
							onChange={(e) => {
								if (viewOnly) {
									displayViewOnlyModal();
									return;
								}
								const newTitle = e.target.value;
								updateCurrentStyle({
									colors: activeStyle.colors.map((c, i) =>
										i === index ? { ...c, title: newTitle } : c
									),
								});
							}}
						/>
					</DS.PropertyLabel>
					<DS.PropertySpacer />
					<DS.PropertyColorWrapper>
						<ColorInput
							color={color.hex}
							onColorChange={(color) => {
								if (viewOnly) {
									displayViewOnlyModal();
									return;
								}
								updateCurrentStyle({
									colors: activeStyle.colors.map((c, i) =>
										i === index ? { ...c, hex: color } : c
									),
								});
							}}
						/>
					</DS.PropertyColorWrapper>
				</DS.PropertyRow>
			))}
			{activeStyle?.colors?.length > 0 ? <Panel.Spacer /> : <Panel.HalfSpacer />}
		</Section>
	);
};

export default ColorSetup;
